import React from 'react';
import SectionWell from "../confirm/SectionWell";
import EditSection from "../confirm/EditSection";
import Insurance from "../Insurance";

const InsuranceInformation = ({
	primaryInsuranceDetails,
	secondaryInsuranceDetails,
	gearOrder,
	userInfo,
	cancelEdit,
	saveEdit,
	editRef,
	editingReq,
	editingSection,
	isEditSaveInProgress,
	inlineSaveError,
	editSection,
	canEditInsurance,
	lastSavedReq,
	lastSavedSection,
	insuranceOptions,
	setInsuranceOptions
}) => {
	if (editingReq === `${gearOrder?.id}` && editingSection === 'insurance') {
		return (<div className="mt-20" data-step={`insurance`}>
			<EditSection
				 title="Insurance"
				 onCancel={cancelEdit}
				 onSave={saveEdit}
				 isEditSaveInProgress={isEditSaveInProgress}
			>
				<Insurance
					 editRef={(ref) => (editRef.current = ref)}
					 userInfo={userInfo}
					 gearOrder={gearOrder}
					 doConfirm={() => {
					 }}
					 setDirty={() => {
					 }}
					 showError={() => {
					 }}
					 setInsuranceOptions={setInsuranceOptions}
					 options={insuranceOptions}
					 setGearOrder={() => {
					 }}
				/>
				{inlineSaveError && <div
					 className="validation-message text-danger text-right">{inlineSaveError}</div>}
			</EditSection>
		</div>);
	}
	return (
		 <div data-step={`insurance`}>
			 <SectionWell sectionId='insuranceInfo' title='Insurance Information'
							  changesSaved={lastSavedReq === `${gearOrder.id}` && lastSavedSection === 'insurance'}
							  editKey={`insurance_${gearOrder.id}`}
							  onEdit={canEditInsurance && editSection}>
				 {primaryInsuranceDetails}
				 {secondaryInsuranceDetails}
			 </SectionWell>
		 </div>
	);
}

export default InsuranceInformation;